// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"825313c2c9dd5f2b6037","452":"13181b4bb14d44f39f86","453":"d0eaf728925b5a16f474","896":"b431fea213b6063f4830"}[chunkId] + ".js";
};